import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Gift } from "lucide-react";
import { SHOP_OPEN_AT } from "@/lib/api";

const getRemaining = () => {
  const diff = new Date(SHOP_OPEN_AT).getTime() - Date.now();
  if (diff <= 0) return null;
  return {
    days: Math.floor(diff / 86400000),
    hours: Math.floor((diff / 3600000) % 24),
    mins: Math.floor((diff / 60000) % 60),
    secs: Math.floor((diff / 1000) % 60),
  };
};

const Box = ({ value, label }) => (
  <div className="bg-candy-cream text-candy-pinkdark border-4 border-candy-gold rounded-2xl shadow-[0_0_30px_rgba(255,215,0,0.35)] px-4 sm:px-8 py-4 sm:py-5 min-w-[78px] sm:min-w-[130px] text-center">
    <div className="font-display text-5xl sm:text-8xl leading-none" data-testid={`countdown-${label.toLowerCase()}`}>
      {String(value).padStart(2, "0")}
    </div>
    <div className="font-mono text-[10px] sm:text-sm font-bold uppercase tracking-widest mt-1 text-candy-teal">{label}</div>
  </div>
);

export const Countdown = () => {
  const [time, setTime] = useState(getRemaining());
  const done = time === null;

  useEffect(() => {
    if (done) return undefined;
    const t = setInterval(() => {
      const r = getRemaining();
      setTime(r);
      if (!r) window.dispatchEvent(new Event("shop-opened"));
    }, 1000);
    return () => clearInterval(t);
  }, [done]);

  if (done) return null;

  return (
    <section className="relative bg-candy-pinkdark border-y-4 border-candy-gold py-12 sm:py-16" data-testid="countdown-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 text-center">
        <div className="inline-flex items-center gap-2 bg-candy-teal text-white border-2 border-candy-gold rounded-full px-4 py-1.5 font-mono text-xs font-bold uppercase tracking-widest mb-4">
          <Gift className="h-4 w-4" /> Shop opens Nov 1 · 12:00 AM CT
        </div>
        <h2 className="font-spooky text-4xl sm:text-6xl text-candy-cream drop-shadow-[3px_3px_0_#000]" data-testid="countdown-heading">
          Christmas Candy Shop Opens In
        </h2>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="mt-8 flex flex-wrap justify-center gap-3 sm:gap-6"
        >
          <Box value={time.days} label="Days" />
          <Box value={time.hours} label="Hours" />
          <Box value={time.mins} label="Mins" />
          <Box value={time.secs} label="Secs" />
        </motion.div>
        <p className="mt-6 font-heading font-600 text-candy-cream text-base sm:text-lg">
          Our Fall &amp; Christmas Candy Bouquets and Stocking Stuffers are coming soon. Merch is available right now!
        </p>
      </div>
    </section>
  );
};
